/** Import at the app entry point before analytics. Keep URL credentials only in memory. */
let credential: string | null = null;
if (typeof window !== 'undefined' && window.location.pathname === '/auth/sms-link') {
  const url = new URL(window.location.href);
  credential = new URLSearchParams(url.hash.slice(1)).get('token') || url.searchParams.get('token');
  url.hash = '';
  url.searchParams.delete('token');
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}`);
}
export function getSmsLinkCredential(): string | null { return credential; }
export function clearSmsLinkCredential(): void { credential = null; }
